export const cancelSportsnewListFlight = (flight) => {
  if (!flight || flight.cancelled) return false;

  flight.cancelled = true;
  flight.abortController?.abort?.();

  const retryWait = flight.retryWait;
  if (retryWait) {
    clearTimeout(retryWait.timer);
    flight.retryWait = null;
    retryWait.resolve(false);
  }
  return true;
};

export const cancelSportsnewListFlights = (flights) => {
  if (!(flights instanceof Map)) return 0;
  let cancelled = 0;
  flights.forEach((flight) => {
    if (cancelSportsnewListFlight(flight)) cancelled += 1;
  });
  flights.clear();
  return cancelled;
};
